import React from 'react'

export default function CrossIcon(props) {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10 10L36 36M10 36L36 10" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
        </svg>

    )
}
